<h4 mat-dialog-title>{{ data?.title }}</h4>

<div mat-dialog-content class="content">
  <table class="list-table">
    <ng-container *ngFor="let item of data?.list">
      <tr>
        <td>{{ item }}</td>
      </tr>
    </ng-container>
  </table>
</div>

<div mat-dialog-actions class="actions">
  <button mat-button mat-dialog-close color="primary">Close</button>
</div>
